import { render, staticRenderFns } from "./BMPLoading.vue?vue&type=template&id=258bc13a"
var script = {}
import style0 from "./BMPLoading.vue?vue&type=style&index=0&id=258bc13a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports